module.exports = __webpack_public_path__ + "static/MysteryB-635c6020de290a01b4ee0e8e7ae2a582.gif";